import { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';
import { GeoSearchControl, GoogleProvider } from 'leaflet-geosearch';
import config from '../../../app/config';
import pinIcon from '../../../static/hoop-pin.svg';

const MinimapSearch = ({ onLocationSearch, position = 'topright' }) => {
  const map = useMap();

  useEffect(() => {
    const provider = new GoogleProvider({ params: { key: process.env.REACT_APP_GOOGLE_GEOCODING_API_KEY } });

    const searchControl = new GeoSearchControl({
      ...config.geosearch,
      provider,
      position,
      marker: L.icon({ iconUrl: pinIcon, iconSize: [ 45, 50 ] }),
      classNames: { form: 'minimap-search-form' },
    });

    map.on('geosearch/showlocation', (event) => onLocationSearch(event.location.raw));

    map.addControl(searchControl);
    return () => map.removeControl(searchControl);
  });

  return null;
};

export default MinimapSearch;
